/** @format */
import * as prefApi from "./userPreferenceApi";
import { isEqual } from "../isEqual";
import { strToType, valueToStrWithType } from "../formatter";
var resourceName = "QuotaModeler";
var appPreference = {
  id: window.AuthProvider.alias,
  ResourceName: resourceName,
  stateContent: []
};
var fetchUserPrefPromise = null;
var appName = "QuotaModeler";
var apiBaseUrl = "https://onemintapidev.azure-api.net/UserPreferenceAPI/";

/*
  Initialization Constructor
  To be called in shell only and not in individual micro-frontends.
  The config object retured will be passed from shell to Micro-frontend. 
  Micro-frontend will pass the config object recieved from Shell to copy constructor.
*/
export function bootstrapUserPreference(userPrefApiBaseUrl, currentAppName) {
  apiBaseUrl = userPrefApiBaseUrl;
  appName = currentAppName;
  fetchUserPrefPromise = fetchUserPreference();
  return {
    fetchUserPrefPromise: fetchUserPrefPromise,
    apiBaseUrl: userPrefApiBaseUrl,
    appName: currentAppName
  };
}

/*
Copy constructor
To be used in shelll, the copyObj will be passed from shell.
*/
export function bootstrapUserPreferenceCopy(copyObj) {
  apiBaseUrl = copyObj.apiBaseUrl;
  appName = copyObj.appName;
  fetchUserPrefPromise = copyObj.fetchUserPrefPromise;
}
function fetchUserPreference() {
  return prefApi.GetUserPreference(appName, apiBaseUrl).then(function (data) {
    if (data.data !== null && data.data !== undefined) appPreference = data.data;
    return appPreference;
  });
}
export function getUserPreferenceAsync(key) {
  if (fetchUserPrefPromise === null) fetchUserPrefPromise = fetchUserPreference(resourceName);
  return fetchUserPrefPromise.then(function (appPref) {
    var preferenceObj = null;
    for (var i = 0; i < appPref.stateContent.length; i++) {
      if (appPref.stateContent[i].key === key) {
        preferenceObj = appPref.stateContent[i];
        break;
      }
    }
    if (preferenceObj === null) {
      return null;
    }
    return strToType(preferenceObj.value, preferenceObj.valType);
  });
}
export function saveUserPreference(key, value) {
  if (key === '' || typeof key !== "string") throw new Error("Invalid User Preference Key!! Use a valid string value");
  getUserPreferenceAsync(key).then(function (currentValue) {
    if (isEqual(currentValue, value)) {
      return;
    }
    if (!appPreference.stateContent) {
      appPreference.stateContent = [];
    }
    for (var i = 0; i < appPreference.stateContent.length; i++) {
      if (appPreference.stateContent[i].key === key) {
        appPreference.stateContent.splice(i, 1);
        break;
      }
    }
    var valueDetails = valueToStrWithType(value);
    appPreference.stateContent.push({
      key: key,
      value: valueDetails.value,
      valType: valueDetails.valType
    });
    prefApi.SaveUserPreference(appName, apiBaseUrl, appPreference.stateContent);
  });
}